<template>
  <div
    ref="profileMenu"
    class="header-profile"
    :class="{ 'profile-expanded': headerData.isProfileExpanded }"
    data-v-step="header-3"
    @click="toggleProfile"
  >
    <!-- Render toggle button for profile menu inside Header -->
    <div class="header-profile-button">
      <i class="fa fa-user" />
      <a>
        <span class="name">{{ modifiedName }}</span>
        <span class="job">{{ appendRolesText(profile.roles.toString()) }}</span>
      </a>
    </div>

    <!-- Render profile menu -->
    <div
      v-show="headerData.isProfileExpanded"
      ref="profileExpandMenu"
      class="header-profile-expand"
    >
      <div class="profile-identity">
        <span>
          <b>{{ modifiedName }}</b>
        </span>
        <span>{{ appendRolesText(profile.roles.toString()) }}</span>
      </div>
      <div class="profile-content">
        <a class="text-title" v-if="isImpersonating" @click="switchBackUser">
          <span>
            <i class="xb-icon-switch" />
          </span>
          <span>SWITCH BACK</span>
        </a>
        <!-- impersonation show for super user -->
        <Impersonation @impersonate="impersonate" :isEA="isEA" v-if="canImpersonate" />
        <ul>
          <li>
            <a class="text-title" href="/aceas/profile-management">
              <span>
                <i class="xb-icon-user" />
              </span>
              <span>USER</span>
            </a>

            <!-- end of impersonation component -->
            <ul v-if="!isImpersonating">
              <li>
                <a class="logout-button" @click="signOut">Sign out</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
const mapState = window.Vuex.mapState;
import Mgr from "./../../../services/securityService.js";
import Impersonation from "./Impersonation.vue";

export default {
  name: "XbaseHeaderProfile",
  components: {
    Impersonation
  },
  data: function() {
    return {
      headerData: {
        isProfileExpanded: false
      },
      isRoleHover: false,
      isUserHover: false,
      mgr: new Mgr(this.$store.state.config.configurationData.common_module)
    };
  },
  computed: {
    profile() {
      return this.$store.state.header.userProfile;
    },
    modifiedName() {
      if (
        this.$store.state.header.userProfile.userName ===
          this.$store.state.header.userProfile.nric ||
        this.$store.state.header.userProfile.userName ===
          this.$store.state.header.userProfile.sgID ||
        !this.$store.state.header.userProfile.isValidated
      )
        return this.$options.filters.maskNRIC(
          this.$store.state.header.userProfile.userName
        );
      else {
        return this.$store.state.header.userProfile.userName;
      }
    },
    ...mapState({
      isImpersonating: state => state.header.isImpersonating,
      profileType: state => state.header.userProfile.profileType,
      nric: state => state.header.userProfile.nric,
      sgID: state => state.header.userProfile.sgID,
      isEA: state =>
        state.header.userProfile.profileType === 1 ? true : false,
      canImpersonate: state => state.header.userProfile.canImpersonate
    })
  },
  created() {
    document.addEventListener("click", this.documentClick);
  },
  destroyed() {
    document.removeEventListener("click", this.documentClick);
  },
  methods: {
    impersonate({ nric, uen }) {
      this.mgr.exchangeToken(nric, uen);
    },
    switchBackUser() {
      const _this = this;
      this.mgr.getSignedIn().then(signedIn => {
        if (signedIn) {
          _this.mgr.getUser().then(user => {
            if (user.profile.nric) {
              _this.mgr.exchangeToken(
                user.profile.nric,
                user.profile.identity_number
              );
            } else {
              _this.mgr.exchangeToken(user.profile.identity_number);
            }
          });
        }
      });
    },
    appendRolesText(arrOfText) {
      if (!arrOfText) {
        return;
      }

      if (arrOfText.length > 25) {
        return arrOfText.substring(0, 25) + "...";
      }

      return arrOfText;
    },
    toggleProfile(e) {
      const { profileExpandMenu } = this.$refs;
      const target = e.target;

      if (profileExpandMenu !== target && !profileExpandMenu.contains(target)) {
        this.headerData.isProfileExpanded = !this.headerData.isProfileExpanded;
      }
    },
    closeProfile() {
      this.headerData.isProfileExpanded = false;
    },
    documentClick(e) {
      const { profileMenu, profileExpandMenu } = this.$refs;
      const target = e.target;
      if (
        profileMenu !== target &&
        !profileMenu.contains(target) &&
        profileExpandMenu !== target &&
        !profileExpandMenu.contains(target)
      ) {
        this.closeProfile();
      }
    },
    mouseEnterRole() {
      this.isRoleHover = true;
    },
    mouseLeaveRole() {
      this.isRoleHover = false;
    },
    mouseEnterUser() {
      this.isUserHover = true;
    },
    mouseLeaveUser() {
      this.isUserHover = false;
    },
    signOut() {
      this.$emit("logout", true);
      this.$store.commit("auth/setIsManuallySignedOut", true);
      this.isLoading = true;
      this.mgr.signOut();
    }
  }
};
</script>
